(() => {
  "use strict";

  function isRetina() {
    return (window.devicePixelRatio || 1) >= 2;
  }

  function addDprToUrl(url, dpr) {
    try {
      if (!url) return url;
      // Only rewrite our /img pipeline URLs
      if (url.indexOf("/img?") === -1) return url;

      // Make it absolute for parsing, then return as-is (absolute is fine)
      const u = new URL(url, window.location.origin);
      if (u.searchParams.has("dpr")) return u.toString();
      u.searchParams.set("dpr", String(dpr));
      return u.toString();
    } catch {
      return url;
    }
  }

  function rewriteSrcset(srcset, dpr) {
    if (!srcset) return srcset;

    // srcset format: "url 200w, url 400w, ..."
    const parts = srcset.split(",");
    const out = parts.map(part => {
      const p = part.trim();
      if (!p) return p;

      // Split "URL" from descriptor "200w" / "2x"
      const firstSpace = p.search(/\s/);
      if (firstSpace === -1) {
        return addDprToUrl(p, dpr);
      }

      const url = p.slice(0, firstSpace).trim();
      const desc = p.slice(firstSpace).trim();
      return `${addDprToUrl(url, dpr)} ${desc}`;
    });

    return out.join(", ");
  }

  function applyDpr(root) {
    if (!isRetina()) return;

    const dpr = 2;

    const images = (root || document).querySelectorAll('img[src*="/img?"], img[srcset*="/img?"]');
    images.forEach(img => {
      if (img.dataset.saDprApplied === "1") return;

      // src
      if (img.getAttribute("src")) {
        img.src = addDprToUrl(img.getAttribute("src"), dpr);
      }

      // srcset
      const ss = img.getAttribute("srcset");
      if (ss) {
        img.setAttribute("srcset", rewriteSrcset(ss, dpr));
      }

      img.dataset.saDprApplied = "1";
    });
  }

  function boot() {
    applyDpr(document);

    // Shopify theme editor / dynamic sections
    document.addEventListener("shopify:section:load", (e) => applyDpr(e.target));
    document.addEventListener("shopify:section:select", (e) => applyDpr(e.target));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
